import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type InviteUserRequestBody = ApiRequestBody<
  typeof endpoints.inviteUser,
  'post'
>;

export const useInviteUserMutation = () => {
  return useMutation({
    mutationFn: async (body: InviteUserRequestBody) => {
      const { data } = await fetchClient.POST(endpoints.inviteUser, { body });
      return data;
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.workspace())();
    },
  });
};
